module.exports = __webpack_public_path__ + "static/media/knowledge_img.185d33bc.jpg";